// extracted by mini-css-extract-plugin
module.exports = {"errorContainer":"search_error_message-module__errorContainer--3wtcd","error":"search_error_message-module__error--1tXJo"};